/**
 * Multinav
 * ======================================
 * - toggle [hidden] attribute on [data-toggle] selector
 * - toggle ELEMENT_LABEL text with [data-toggle-label] attribute
 */
 const ISMOBILE = window.matchMedia("only screen and (max-width: 991px)").matches
 const WIDGET = ".js-Multinav";
 const SUB_ELEMENT = '.tabs-multinav__item-groups'
 const TOGGLE_CLASS = "is-open";
 const DEFAULTACTIVECLASS = 'is-open-default'

 class Multinav {
   constructor() {
     this.elements = document.querySelectorAll(WIDGET);

     if (!this.elements) {
       return false;
     }

     this.elements.forEach((el) => {
      const nav = el.querySelectorAll('.tabs-multinav__item-header')

      nav.forEach((navEl) => {
        navEl.addEventListener('click', this.clickHandler)
      })

      document.addEventListener('DOMContentLoaded', () => {
          this.initOpen(el)
      });
     });
   }

   setHeight = (tab, close = false) => {
    const sub = tab.querySelector(SUB_ELEMENT)

    if (ISMOBILE) {
      var height = sub.scrollHeight
      var heightEl = sub
    } else {
      var height = sub.scrollHeight + 68
      var heightEl = sub.closest(WIDGET)
    }

    if(close){
      heightEl.style.height = 0
    } else {
      heightEl.style.height = height + 'px'
    }
  }

  setMinHeight = (widget) => {
    const navItems = widget.querySelectorAll('.tabs-multinav__item')
    var mHeight = 0

    navItems.forEach((navEl) => {
      mHeight = mHeight + navEl.scrollHeight
    })

    widget.style.minHeight = mHeight + 'px'
  }

  initOpen = (widget) => {
    const activeTab = widget.querySelector('.tabs-multinav__item.'+DEFAULTACTIVECLASS)

    this.setHeight(activeTab)

    activeTab.classList.remove(DEFAULTACTIVECLASS)

    if (!ISMOBILE) {
      this.setMinHeight(widget)
    }
  }

  closeAll = () => {
    const elements = document.querySelectorAll('.tabs-multinav__item.is-open')

    elements.forEach((el) => {
      el.classList.remove(TOGGLE_CLASS);
    });
  }

  clickHandler = (e) => {
    const button = e.currentTarget;
    const target = button.parentNode;
    const classes = target.classList

    if(!ISMOBILE){
      this.closeAll()
    }

    if(classes.contains(TOGGLE_CLASS)){
      classes.remove(TOGGLE_CLASS)
      this.setHeight(target, true)
    } else {
      classes.add(TOGGLE_CLASS)
      this.setHeight(target)
    }

    e.preventDefault();
  }

 }

 new Multinav();
